// File: frontend/src/components/VendorFooter.jsx

import React from 'react';
import { useSchool } from '../context/SchoolContext';

const VendorFooter = () => {
  const { school } = useSchool();

  return (
    <footer className="w-full py-3.5 px-6 bg-slate-900 text-slate-400 text-xs font-sans border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-2 print:hidden z-20">
      <div className="flex items-center gap-2">
        <span className="font-bold text-white">{school?.name || 'MarkazSchool Pro'}</span>
        <span className="text-slate-600">•</span>
        <span className="text-slate-400">{school?.portal_name || 'School Management Engine'}</span>
      </div>

      {/* LOCKED IMMUTABLE VENDOR CREDIT */}
      <div className="flex items-center gap-1.5 text-slate-400 text-[11px]">
        <span>© {new Date().getFullYear()}</span>
        <strong className="text-white font-semibold">MarkazSchool Pro</strong>
        <span className="text-slate-500">•</span>
        <span>Powered & Maintained by</span>
        <a 
          href="mailto:support@waleedtech.com" 
          className="text-blue-400 font-bold hover:text-blue-300 transition"
          target="_blank" 
          rel="noopener noreferrer"
        >
          Waleed Technologies
        </a>
      </div>
    </footer>
  );
};

export default VendorFooter;
